import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig, DwLookupInfo, DwMetaDataService, DwMetaDataServiceToken, getMomentValue } from '@devwareapps/devware-cap';
import { AirportEntity, AirportWithAddressInfoQueryEntity, AppMetaDataLookups } from '../../../../meta-data/app-meta-data.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { Observable } from 'rxjs';
import { DateTimeUtilService } from '../../util/date-time-util.service';

@DwComponent({
  key: 'pilexos-email-display',
  name: 'E-mail Display',
  componentType: DwComponentType.formControl,
  isGlobal: true
})

@Component({
  selector: 'app-email-display',
  template: `
  <div class="read-only">
    <a href="mailto:{{email}}" *ngIf='email'>{{email}}</a>
    <ng-container *ngIf="!email">{{missingTextData}}</ng-container>
  </div>
`
})
export class EmailDisplayComponent implements DwFormControl , DwFormControlInit, OnDestroy {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  context: DwContext;
  useDisplayField?: boolean;
  
  email?:string;
  missingTextData: string;
  subscription: any;

  constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  initControl(): void {
    // More checks needed since the data might not be loaded yet
    this.email = this.control.value;

    this.missingTextData = this.fieldDef.readOnlyMissingDataText || 'None';

    this.subscription = this.control.valueChanges.subscribe((value) => {
      this.email = value;
    });
  }

   /*
   * Returns the rating Form Control to get or set it's value
   */
   get control(): AbstractControl {

    
    return this.formGroup.get(this.fieldDef.attrName);
  }

}